// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"7f9d64db","513":"773dc4ac","664":"020c77b9","665":"0f45abc9","706":"cc727622"}[chunkId] + ".chunk.js";
};